
const sectorsData = [
  {
    title: "Construction",
    description: "IMMACULATE provides skilled manpower solutions for the construction industry. From project managers and site engineers to skilled laborers and safety officers, we supply qualified personnel who understand the demands of construction projects. Our commitment to safety, quality, and timely delivery ensures your projects stay on track.",
    imageUrl: "/assest/section-showcase/architect-man-showing-something-project-his-colleague-foreman.jpg",
  },
  {
    title: "E-Commerce & Delivery",
    description: "In the fast-moving domain of E-commerce, dependable delivery services are vital for success. IMMACULATE is your trusted partner, offering highly qualified drivers to meet the unique needs of E-commerce businesses. With a diverse pool of drivers and a dedication to comprehensive delivery solutions, we support your end-to-end logistics.",
    imageUrl: "/assest/section-showcase/delivery.jpg",
  },
  {
    title: "Hospitality & Retail",
    description: "With extensive experience in the hospitality and retail sectors, IMMACULATE has established itself as one of the leading staffing firms in the UAE. The company has a deep understanding of the needs of these sectors and is able to provide businesses with the right staff to meet their specific requirements.",
    imageUrl: "/assest/section-showcase/retail-12.jpg",
  },
  {
    title: "Events & Entertainment",
    description: "IMMACULATE is a leading provider of innovative solutions in the entertainment and events industry. Our team of experts has a wealth of experience in creating and delivering unforgettable events, from small corporate functions to large-scale festivals.",
    imageUrl: "/assest/section-showcase/event_ent-9.jpg",
  },
  {
    title: "Aviation",
    description: "IMMACULATE offers customizable manpower and staffing solutions for government and aviation services. We have a deep understanding of the specific needs of these domains, providing the right staff to meet their requirements. We also offer a range of value-added services, such as payroll processing, training, and compliance.",
    imageUrl: "/assest/section-showcase/Aviation.jpg",
  },
  {
    title: "Warehouse & Logistics",
    description: "Finding reliable and skilled warehouse workers can be a daunting task for any business. At IMMACULATE, we specialize in sourcing highly skilled and dependable warehouse staff. Our global reputation is built on our commitment to quality and expertise in warehouse, logistics, and e-commerce operations. We also hold an exclusive Jafza license, making us the go-to manpower provider in this distinguished economic zone.",
    imageUrl: "/assest/section-showcase/logistic-11.jpg",
  },
  {
    title: "Healthcare",
    description: "We have consistently maintained our position as the top manpower and staffing solution provider for the health care domain in the UAE. Our in-depth understanding of the sensitive requirements in the sector has allowed us to stand by our promise of providing excellent solutions.",
    imageUrl: "/assest/section-showcase/doct-14.jpg",
  },
  {
    title: "Banking & Finance",
    description: "We have a deep understanding of the banking and trading sector. We know what skills and experience are required for different roles, and we have a network of qualified candidates who can meet your needs.",
    imageUrl: "/assest/section-showcase/banking-15.jpg",
  },
  {
    title: "Technology Solutions",
    description: "In a rapidly changing world, the IT sector is a hub of innovation and opportunities. IMMACULATE opens the door to endless possibilities in this dynamic field, combining technology and innovation to shape the future. We explore the world of data-driven insights, intelligent automation, and transformative solutions that are shaping businesses and societies.",
    imageUrl: "/assest/section-showcase/tech-16.jpg",
  },
];

const SectorsShowcase = () => {
  return (
    <section id="sectors" className="bg-white py-12 sm:py-16 md:py-20 lg:py-16">
      <div className="container mx-auto px-5 sm:px-6 lg:px-4">
        <div className="text-center max-w-4xl mx-auto mb-10 sm:mb-12 md:mb-16">
          <h2 className="font-display text-3xl sm:text-[36px] md:text-[42px] lg:text-[52px] font-bold text-brand-navy !leading-tight">
            Our Domain Prowess
          </h2>
          <blockquote className="mt-4 sm:mt-6">
            <p className="quote-text text-text-medium text-base sm:text-lg md:text-xl">
              "It is not the ship so much as the skillful sailing that assures the prosperous voyage."
            </p>
            <footer className="mt-2 quote-attribution text-brand-navy text-sm">- George William Curtis</footer>
          </blockquote>
          <p className="mt-4 sm:mt-6 text-text-dark text-sm sm:text-base max-w-3xl mx-auto leading-relaxed">
            IMMACULATE offers customized solutions tailored to the specific needs of each business or industry. Whether it is facilities management for events, hospitality, healthcare, warehouse &amp; logistics, or commerce &amp; delivery, we provide innovative, bespoke solutions that include efficient staff payment, mobile workforce management, complex schedule handling, and a variety of other details.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
          {sectorsData.map((sector) => {
            const sectorLinks: { [key: string]: string } = {
              "E-Commerce & Delivery": "/ecommerce-delivery",
              "Events & Entertainment": "/entertainment-events",
              "Aviation": "/aviation-and-government",
              "Warehouse & Logistics": "/logistics",
              "Hospitality & Retail": "/hospitality",
              "Healthcare": "/health-care",
              "Banking & Finance": "/banking-finance",
              "Technology Solutions": "/it",
              "Construction": "/construction"
            };
            
            return (
              <a
                key={sector.title}
                href={sectorLinks[sector.title] || "#"}
                tabIndex={0}
                className="group relative cursor-pointer overflow-hidden rounded-lg sm:rounded-xl shadow-lg hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 transition-shadow duration-300 min-h-[280px] sm:min-h-[320px] md:min-h-[360px] lg:min-h-[400px] block"
              >
                <img
                  src={sector.imageUrl}
                  alt={sector.title}
                  className="absolute inset-0 object-cover w-full h-full transition-all duration-500 ease-in-out group-hover:scale-105 group-hover:brightness-110 group-focus-within:scale-105 group-focus-within:brightness-110"
                  style={sector.title === "E-Commerce & Delivery" ? { objectPosition: 'center 35%' } : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent"></div>
                <div className="absolute inset-0 p-5 sm:p-6 flex flex-col justify-end">
                  <h3 className="font-display text-xl sm:text-2xl md:text-[26px] font-semibold text-white !leading-tight transition-all duration-300 ease-in-out">
                    {sector.title}
                  </h3>
                    <p className="text-white/95 text-sm sm:text-[15px] leading-relaxed mt-2 max-h-0 opacity-0 group-hover:max-h-60 group-hover:opacity-100 group-focus-within:max-h-60 group-focus-within:opacity-100 transition-all duration-500 ease-in-out overflow-hidden">
                      {sector.description}
                    </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectorsShowcase;